<template>
  
    <content-header
        icona="fas fa-graduation-cap"
        titolo="Docenti"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">

           <!-- *** GRIGLIA DOCENTI *** -->
           <div class="card" v-if="mostraGrigliaDocenti">
                <div class="card-body">

                    <button type="button" class="btn btn-dark" @click="GetListDocenti()">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;
                    <button type="button" class="btn btn-success" @click="AttivaEditDocente">
                        <i class="fas fa-plus"></i>&nbsp;Nuovo Docente
                    </button>&nbsp;
                    <button type="button" class="btn btn-secondary" @click="EsportaListaDocenti">
                        <i class="fas fa-file-excel"></i>&nbsp;Esporta elenco
                    </button>
                    <br /><br />

                    <div class="d-flex justify-content-start">
                        <div class="form-group mx-2 " style="width:350px">
                            <label>Ricerca testuale</label>
                            <input type="text" class="form-control form-control-sm" placeholder="cerca per ..." v-model="reqGrigliaDocenti.Testuale" @keyup.enter="GetListDocenti" />
                        </div>
                        
                        <div class="from-group mx-2">
                            
                            <a class="btn btn-sm btn-dark" @click="AzzeraFiltri" style="margin-top:30px;">
                            <i class="fas fa-times"></i>&nbsp;Azzera
                            </a>&nbsp;
                            <a class="btn btn-sm btn-info" @click="GetListDocenti" style="margin-top:30px;" >
                            <i class="fas fa-search"></i>&nbsp;Cerca
                            </a>
                        </div>
                    </div>  
                    <div class="d-flex justify-content-start">
      

                    </div>
                    
                    
                    <br/>
                    <griglia-facile
                        :colonne-header="g_colonneHeader"
                        :colonne="g_colonne"
                        :colonneNoOrder="g_colonneNoOrder"
                        :colonneAlign="g_colonneAlign"
                        :comandi="g_comandi"
                        :mostraPager="true"
                        classi-table="table-sm table-hover table-custom"
                        :dati="dtDocenti"
                        :queryLength="g_queryLength"
                        :currentPage="g_currentPage"
                        
                        @Seleziona="SelectDocente"
                        @Cancella="DelElemDocenti"
                        @Ordina="OrdinaGriglia"
                        
                        @CambiaElementi="CambiaElementi"
                        @Precedente="PaginaPrecendente"
                        @Successiva="PaginaSuccessiva"
                        @CambiaPagina="CambiaPagina"
                       

                        fontawesome="standard"

                        ></griglia-facile>

                </div>
            </div>

            <!-- *** EDIT Docente *** -->
            <div class="card" v-if="mostraEditDocente">
            <div class="card-header">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocente(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocente(false)">Salva e Chiudi</button>
            </div>
            <div class="card-body">
                

                <form autocomplete="off">

                <messaggio-standard 
                    :mostraMessaggio="mostraMessaggio"
                    :alertClass="alertClass"
                    :alertIcon="alertIcon"
                    :alertIconSpin="alertIconSpin"
                    :alertMessaggio="alertMessaggio"
                    fontawesome="standard"
                    ></messaggio-standard>
                    
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-info text-primary"></i>&nbsp;Dati generali
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Cognome</label>
                        <input type="text" v-model="oDocente.doc_cognome" class="form-control">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Nome</label>
                        <input type="text" v-model="oDocente.doc_nome" class="form-control">
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Email</label>
                        <input type="text" v-model="oDocente.doc_email" class="form-control">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Cellulare</label>
                        <input type="text" v-model="oDocente.doc_cell" class="form-control">
                    </div>
                </div>

                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-lock text-warning"></i>&nbsp;Autorizzazioni
                    </div>
                </div>
                <small class="mb-2">Per disattivare l'accesso al docente lasciare in bianco le credenziali.</small>

                <div class="row">
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Username (accesso piattaforma esami)</label>
                        <input type="text" v-model="oDocente.doc_user" class="form-control" placeholder="Username accesso piattaforma esami" autocomplete="new-password">
                    </div>
                    <div class="col-md-6 mb-3">
                        <label class="form-label">Password</label>
                        <input type="password" v-model="oDocente.doc_pass" class="form-control" autocomplete="new-password">
                    </div>

                </div>

                              
                

                </form>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocente(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaDocente(false)">Salva e Chiudi</button>
            </div>
            </div>

        </div>
    </div>

    <iframe id="iFrameDn" name="iFrameDn" src="about:blank" style="display:none"></iframe> 
    
</template>

<script>
import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'DocentiView',
    components: {
        ContentHeader, GrigliaFacile, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            dtDocenti: [],
            dtPartecipanti: [],
            dtClienti: [],
            dtDocentiStati: [],
            dtPersonale: [],

            //variabili per aggiunta partecipante
            idAnaSelParp: -1,
            idPerSelParp: -1,

            //Impostazioni griglia Docenti
            g_colonne: ['doc_id', 'doc_cognome', 'doc_nome', 'doc_user', 'doc_email', 'doc_cell'],
            g_colonneHeader: ['Id', 'Cognome', 'Nome', 'Username', 'Email', 'Cell.'],
            g_colonneNoOrder: ['doc_email', 'doc_cell'], 
            g_colonneAlign: [
                
            ],
            g_comandi: 
            [
                {titolo:'Cancella', icona:'fa-trash', iconaStile: 'btn btn-xs btn-outline-danger', emetti: 'Cancella'},
            ],
            g_queryLength: 0, //lunghezza della query (che NON è la lunghezza del dataset passato)
            g_currentPage: 1, //pagina corrente

            //Oggetto richiesta griglia
            reqGrigliaDocenti: {
                ele_pag: 10,
                start: 0,
                orderColumn: "doc_cognome",
                orderDir:"ASC",
                token: this.$store.state.UserInfo.token,
                //Campi custom
                Testuale: "",
                
            },

            oDocente: {
                doc_id: -1,
                doc_nome: "",
                doc_cognome: "",
                doc_email: "",
                doc_cell: "",
                doc_user: "",
                doc_pass: "",

                token: "",
            },

         

            mostraGrigliaDocenti: true,
            mostraEditDocente: false,

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false
           
        
        }
    },
    methods: {
        // GESTIONE PANNELLI E PULIZIA INPUT
        AttivaGriglia() {
            this.mostraEditDocente = false;
            this.mostraGrigliaDocenti = true;

            this.GetListDocenti();
        },
        AzzeraFiltri() {
            this.reqGrigliaDocenti.Testuale = "";
            this.GetListDocenti();
        },
        AttivaEditDocente() {
            this.mostraEditDocente = true;
            this.mostraGrigliaDocenti = false;
            
            this.ClearMessaggio();
            this.ClearDocente();

        },
        ClearDocente() {
            this.oDocente = {
                doc_id: -1,
                doc_nome: "",
                doc_cognome: "",
                doc_email: "",
                doc_cell: "",
                doc_user: "",
                doc_pass: "",
                                
                token: "",
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
        
        // *** OPERAZIONI DI BASE SU Docenti
        GetListDocenti() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento griglia docenti...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Docenti/GetListDocenti" , {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.reqGrigliaDocenti)
            }).then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Griglia caricata.'], 'alert alert-success', 'fa-check', false, 2000]});
                
                        for(let i = 0; i<obj.moreJsonData.length; i++){
                           
                            
                        }

                        


                        this.dtDocenti = obj.moreJsonData;
                        this.g_queryLength = parseInt(obj.dati[0], 10);
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errore caricamento griglia.'], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                });
        },
        GetElemDocenti(idelem) {
            //Carica elemento singolo
            fetch(this.cfg.apisrv + "/api/Docenti/GetElemDocenti?token=" + this.$store.state.UserInfo.token + "&idDoc=" + idelem)
            .then(response => response.json())
            .then(obj => {

                this.oDocente = obj;

                this.mostraGrigliaDocenti=false;
                this.mostraEditDocente= true;

                this.$store.commit('Messaggio', {parms: [true, ['Docente caricato.'], 'alert alert-success', 'fa-check', false, 2000]});

            });
        },
        //Esporta su Excel
        EsportaListaDocenti() {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&orderColumn=" + this.reqGrigliaDocenti.orderColumn + "&orderDir=" + this.reqGrigliaDocenti.orderDir +
                    "&Testuale=" + this.reqGrigliaDocenti.Testuale;
            let url =this.cfg.apisrv + "/api/Docenti/EsportaListaDocenti" + qy;
            let iFrameDn = document.getElementById("iFrameDn");
            iFrameDn.src = url;
          
        },
        //modifica Docente 
        SelectDocente(o)  {
            this.GetElemDocenti(o.doc_id);
        },

        SalvaDocente(reload) {
            let oSubmit = [];
            oSubmit = this.oDocente;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            this.ClearMessaggio();
            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in Docente...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Docenti/SalvaDocente", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        if(reload)  {
                            this.GetElemDocenti(obj.dati[0]);
                        }
                        else {
                            //Fa redirect
                            this.AttivaGriglia();
                        }
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

        },

        DelElemDocenti(e) {
            //Cancella elemento singolo
            if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv + "/api/Docenti/DelElemDocenti?token=" + this.$store.state.UserInfo.token + "&idDoc=" + e.doc_id)
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Eliminato'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.GetListDocenti(); 
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }

        },


       

        // *** CARICAMENTO TABELLE SERVIZIO
    

        //PAGINAZIONE GRIGLIA
        CambiaElementi(nrElem) {
            this.reqGrigliaDocenti.ele_pag = nrElem;
            this.GetListDocenti();
        },
        PaginaPrecendente() {
            this.reqGrigliaDocenti.start = this.reqGrigliaDocenti.start - parseInt(this.reqGrigliaDocenti.ele_pag, 10);
            this.g_currentPage--;
            this.GetListDocenti();  
        
        },
        PaginaSuccessiva() {
            this.reqGrigliaDocenti.start = this.reqGrigliaDocenti.start + parseInt(this.reqGrigliaDocenti.ele_pag, 10);
            this.g_currentPage++;
            this.GetListDocenti();
        
        },
        CambiaPagina(pag) {
            this.reqGrigliaDocenti.start = (parseInt(this.reqGrigliaDocenti.ele_pag, 10) * pag) - parseInt(this.reqGrigliaDocenti.ele_pag, 10);
            this.g_currentPage = pag;
            this.GetListDocenti();
        },

        // ORDINA LA GRIGLIA
        OrdinaGriglia(i) {
            if(this.reqGrigliaDocenti.orderColumn == this.g_colonne[i]) {
                //Stessa colonna
                if(this.reqGrigliaDocenti.orderDir == 'DESC') {this.reqGrigliaDocenti.orderDir = 'ASC';}
                else {this.reqGrigliaDocenti.orderDir = 'DESC';}
            }
            else {
                //altra colonna
                this.reqGrigliaDocenti.orderColumn = this.g_colonne[i];
                this.reqGrigliaDocenti.orderDir = 'DESC';
                
            }
            
            this.GetListDocenti();

        },
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListDocenti();

    }
}
</script>